import React, { FC } from 'react'
import { Button, Col, Container, Row, Tab, Nav } from 'react-bootstrap'
import { SubText, TitleH2 } from 'components/Common/Typography'
import Link from 'next/link'
import Image from 'next/image'
import LinkButton from 'components/LinkButton'

const SolutionsIndustries: FC<{ data }> = ({ data }) => {
  return (
    <section className="emergingtech-solutions-industries  pt-120px pb-120px px-2 px-lg-0">
      <Container>
        <Row className="text-left mb-0">
          <Col xl={7}>
            <TitleH2 text={data?.title} className="mb-0 text_black" />
          </Col>
        </Row>
      </Container>
      <div className="mt-2">
        <Container>
          <Row className="">
            <Col xs={12}>
              <Tab.Container id="left-tabs-example" defaultActiveKey="tab1">
                <Row className="">
                  <Col lg={4} className="mb-4 mb-md-0 pe-lg-5">
                    <SubText
                      className="text_para mb-5 pt-2 pe-0 me-0"
                      text={data?.text}
                    />
                    <Nav className="flex-column box-tab-menu">
                      {data?.boxTab?.map((conVal, i) => {
                        return (
                          <React.Fragment key={conVal.id}>
                            <Nav.Item className="tab_item">
                              <Nav.Link
                                key={i}
                                eventKey={`tab${i + 1}`}
                                className="cursor-pointer"
                              >
                                <span>{conVal.tabTitle}</span>
                              </Nav.Link>
                            </Nav.Item>
                          </React.Fragment>
                        )
                      })}
                    </Nav>
                  </Col>
                  <Col lg={7} className="ps-lg-3 pt-3">
                    <Tab.Content className="bg_black">
                      {data?.boxTab?.map((conVal, i) => {
                        return (
                          <React.Fragment key={conVal.id}>
                            <Tab.Pane eventKey={`tab${i + 1}`}>
                              <div className="d-flex">
                                <div className="content_col col-md-12">
                                  <div className="mb-4">
                                    <Image
                                      src={`${conVal.tabIcons}`}
                                      width={110}
                                      height={110}
                                      quality={80}
                                      alt={conVal.tabTitle}
                                    />
                                  </div>
                                  <h2 className="title_sm mb-3">
                                    {conVal.tabTitle}
                                  </h2>
                                  {conVal?.tabContent?.map((tabtext) => (
                                    <p className="mb-3 text_para text-light-third" key={tabtext}>
                                      {tabtext}
                                    </p>
                                  ))}
                                  <LinkButton
                                    path="/contact-us"
                                    className="text-decoration-none"
                                  >
                                    Talk To Our Expert
                                  </LinkButton>
                                </div>
                              </div>
                            </Tab.Pane>
                          </React.Fragment>
                        )
                      })}
                    </Tab.Content>
                  </Col>
                </Row>
              </Tab.Container>
            </Col>
          </Row>
        </Container>
      </div>
    </section>
  )
}

export default SolutionsIndustries
